<template>
  <v-app-bar elevation="0" app>
    <v-col cols="4" class="pa-0">
      <v-btn @click="$store.commit('viewstate/openNavigation')" icon>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="4" class="d-flex justify-space-around pa-0">
      <v-img
        height="56"
        aspect-ratio="2"
        rel="preload"
        contain
        v-show="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
        :src="$store.getters['config/getOrganizationLogo']"
      />
    </v-col>
    <v-col cols="4" class="d-flex justify-end pa-0">
      <v-switch
        style="height:48px; padding-top:12px"
        v-model="$vuetify.theme.dark"
      ></v-switch>
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="mr-2">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="route('login')">
            <v-list-item-title>
              {{ this.$t("button.logout") }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-app-bar>
</template>

<script>
import CookieHelper from "@/helpers/CookieHelper";

export default {
  name: "AppBar",
  methods: {
    route(routeName) {
      CookieHelper.unsetCookie("user");
      localStorage.removeItem("authorized");
      this.$router.push(routeName);
    }
  }
};
</script>

<style scoped>
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: #fff;
}
</style>
